import routes from '@/constants/routes';

export default {
  APP_STORE: {
    textKey: 'main.app.downloadAppStore',
    shortTextKey: 'main.app.downloadApp',
    icon: '/icons/apple.svg',
    modifier: 'apple',
    alt: 'App store',
    url: routes.APP_STORE,
    withBackground: true,
    isApple: true,
  },
  GOOGLE_PLAY: {
    textKey: 'main.app.googlePlay',
    icon: '/icons/google-play.svg',
    modifier: 'google',
    alt: 'Google play',
    url: routes.GOOGLE_PLAY,
    withBackground: true,
  },
  HUAWEI_STORE: {
    icon: '/icons/huawei.svg',
    alt: 'Huawei',
    url: routes.HUAWEI_STORE,
  },
  MI_STORE: {
    icon: '/icons/mi.svg',
    alt: 'Mi',
    url: routes.MI_STORE,
  },
};
